import { render, staticRenderFns } from "./tree-single-select.vue?vue&type=template&id=e5160cfe&"
import script from "./tree-single-select.vue?vue&type=script&lang=js&"
export * from "./tree-single-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports